// Pages
import RouterView from '@/components/pages/RouterView/Router'

import Distributor from '@/components/pages/Distributors/Distributor.vue'
import EditDistributor from '@/components/pages/Distributors/EditDistributor.vue'

export default {
  path: '/rayner_distributors',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      redirect: '/users'
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: Distributor,
          props: true,
          name: 'view-distributor'
        },
        {
          path: 'edit',
          component: EditDistributor,
          props: true,
          name: 'edit-distributor',
          meta: {breadcrumb: 'Edit Distributor'}
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/distributors.js